module.exports = __webpack_public_path__ + "static/media/bg.6dd92709.png";